import { createFetcher } from "api/helpers"
import { resourceState } from "constants/Constants"
const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, project, params) => {
    return `${host}/security/${project}/get_vuln_comp_by_host_details?${params}`
  },
  checkRequiredArguments: (params) => {
    if (params === undefined);
  },
  makeResponseData: (json) => {
    const copyJson = json?.map((item) => {
      return {
        ...item,
        resource_state: item.reason.includes(resourceState)
          ? "SCAN NEVER PERFORMED"
          : item.resource_state
      }
    })
    return copyJson
  }
}
export default createFetcher(fetcherConfiguration)
